import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeft, HelpCircle } from "lucide-react";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useCreateChecklist } from "../api/queries";
import {
  ChecklistFormTour,
  useChecklistFormTour,
} from "../tour/ChecklistFormTour";
import { ChecklistForm } from "../ui/ChecklistForm";

export function ChecklistCreatePage() {
  const nav = useNavigate({ from: "/app/checklists/new" });
  const createChecklist = useCreateChecklist();
  const formTour = useChecklistFormTour();

  return (
    <>
      <Header />
      <Main>
        <div className="space-y-6">
          {/* Header Section */}
          <div className="flex items-center justify-between">
            <div>
              <div className="flex items-center space-x-2">
                <h1 className="font-bold text-2xl">ສ້າງ Checklist ໃໝ່</h1>

                <Button
                  variant="ghost"
                  size="icon"
                  className="size-7 rounded-full"
                  onClick={formTour.startTour}
                >
                  <HelpCircle className="size-5" />
                </Button>
              </div>
              <p className="mt-1 text-muted-foreground">
                ສ້າງ Checklist ໃໝ່ສໍາລັບການນໍາໃຊ້
              </p>
            </div>
            <div className="flex gap-2">
              <Button
                variant="outline"
                onClick={() => {
                  nav({ to: "/app/checklists" });
                }}
              >
                <ArrowLeft className="mr-2 h-4 w-4" />
                ກັບ
              </Button>
            </div>
          </div>

          {/* Create Form Section */}
          <ChecklistForm
            onSubmit={async (vals) => {
              await createChecklist.mutateAsync({
                title: vals.title,
                description: vals.description ?? undefined,
                typeId: vals.typeId,
                departmentId: vals.departmentId ?? undefined,
                status: vals.status,
                scheduleType: vals.scheduleType,
                scheduleFrequency:
                  vals.scheduleType === "scheduled"
                    ? (vals.scheduleFrequency ?? undefined)
                    : undefined,
                scheduleDayOfWeek:
                  vals.scheduleType === "scheduled" &&
                  vals.scheduleFrequency === "weekly"
                    ? (vals.scheduleDayOfWeek ?? undefined)
                    : undefined,
                scheduleDayOfMonth:
                  vals.scheduleType === "scheduled" &&
                  vals.scheduleFrequency === "monthly"
                    ? (vals.scheduleDayOfMonth ?? undefined)
                    : undefined,
                requireAllItems: vals.requireAllItems,
                requirePhoto: vals.requirePhoto,
                requireNotesOnFail: vals.requireNotesOnFail,
                items: vals.items?.map((item, index) => ({
                  ...item,
                  order: item.order ?? index,
                })),
              });
              nav({ to: "/app/checklists" });
            }}
            submitting={createChecklist.isPending}
          />
        </div>

        <ChecklistFormTour
          run={formTour.run}
          onCallback={formTour.handleJoyrideCallback}
        />
      </Main>
    </>
  );
}
